import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { logout } from "../store/authSlice";
import { changeStatus } from "../store/urlSlice";
import usePrivate from "../store/useAxiosPrivate2";
function CompanyData() {
  const { sendRequest } = usePrivate();
  const selectedCompany = useSelector(state => state.auth.selectedCompany);
  const [companyData, setCompanyData] = useState();
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const userFullName = useSelector(state => state.auth.userFullName);
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    dispatch(changeStatus({ status: null }));
  };
  const GetData = async () => {
    console.log(selectedCompany);
    try {
      const res = await sendRequest(
        "GET",
        `GetData/CompanyData/${selectedCompany}`,
        null
      );
      console.log(res);
      if (res) {
        console.log(res);
        console.log(companyData);
        setCompanyData(res);
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    GetData();
  }, []);

  return (
    <ul className="mob-settings">
      <button className="companyShareButton">
        <i class="fa-solid fa-square-share-nodes"></i>
      </button>
      <div className="companyData">
        <ul className="companyDataFirstUl">
          <li>{t("VÖEN")}:</li>
          <li>{t("Əsas bank hesabı:")}:</li>
          <li>{t("Hesablaşma hesabı:")}:</li>
          <li>{t("Hüquqi ünvan:")}:</li>
          <li>{t("Emailünvanı")}:</li>
          <li>{t("Əlaqə nömrəsi")}:</li>
          <li>{t("Direktorun adı, soyadı")}:</li>
          <li>{t("Rəhbərin vəzifəsi")}:</li>
        </ul>

        <ul className="companyDataSecondUl">
          <li>{companyData?.companiesDataVoen} </li>
          <li>{companyData?.companiesDataMainBankAcoount}</li>
          <li>{companyData?.companiesDataBankAcoount}</li>
          <li>{companyData?.companiesDataAdress}</li>
          <li>{companyData?.companiesDataEmail}</li>
          <li>{companyData?.companiesDataPhoneAz}</li>
          <li>{companyData?.companiesDataFullName}</li>
          <li>{companyData?.companiesDataPosition}</li>
        </ul>
      </div>
    </ul>
  );
}

export default CompanyData;
